/**
 * /welcome/accept?token=… — the URL the provisioning invite email links to (PUBLIC_WEB_URL/welcome/accept).
 * Bridges that link to the existing accept-invite screen, preserving the token. Public (the owner has no
 * session yet). Fixes the prior mismatch where the email pointed at /welcome/accept but the app route was
 * /accept-invite.
 */
import { Redirect, useLocalSearchParams } from 'expo-router';

export default function WelcomeAcceptScreen() {
  const { token } = useLocalSearchParams<{ token?: string }>();
  return <Redirect href={token ? `/accept-invite?token=${encodeURIComponent(token)}` : '/accept-invite'} />;
}
